import { DataTable, DataTablePagination } from 'components/common'
import { bundleProductColumns } from './bundleProductColumns'
import { useLocation, useNavigate } from 'react-router-dom'
import { RowClickedEvent } from '@ag-grid-community/core'
import { PAGE_MASTER_DATA_UPDATE } from 'utils/constants'
import { memo, useEffect, useState } from 'react'
import { useQuery } from 'hooks'
import { fetchBundleProducts } from 'utils/api/bundleProductApi'
import { filterEmptyValues } from 'utils/helpers'
import { SetSelectedColumns } from 'types/dataTable'

type Props = {
  isEditor: boolean
  setSelectedColumns: SetSelectedColumns
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const BundleProductTable = ({
  isEditor,
  setSelectedColumns,
  loading,
  setLoading,
}: Props) => {
  const [bundleProductResponse, setBundleProductResponse] = useState<any>({})

  const navigate = useNavigate()
  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const getBundleProducts = async () => {
    setLoading(true)
    const { limit, page, search, bundleProductFilters } = getAllQueries()

    const filters = filterEmptyValues(bundleProductFilters)

    try {
      const { data } = await fetchBundleProducts({
        limit: limit || 10,
        page: page || 1,
        search: search,
        filters: filters,
      })
      setSelectedColumns(data?.tableConfig?.bundleProduct || [])

      setBundleProductResponse({ ...data })
    } catch (error) {
      setBundleProductResponse({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getBundleProducts()
    // eslint-disable-next-line
  }, [search])

  const onRowClicked = (event: RowClickedEvent) => {
    if (!isEditor) return
    navigate(`${PAGE_MASTER_DATA_UPDATE.path}/${event.data._id}`)
  }

  return (
    <>
      <DataTable
        columns={loading ? [] : bundleProductColumns}
        rows={loading ? null : bundleProductResponse?.docs}
        identifier="_id"
        onRowClicked={isEditor ? onRowClicked : () => {}}
        activeColumnsKey="bundleProduct"
        activeColumns={bundleProductResponse?.tableConfig?.bundleProduct || []}
      />

      <DataTablePagination
        currentPage={bundleProductResponse?.page}
        totalPages={bundleProductResponse?.totalPages}
        hasNextPage={bundleProductResponse?.hasNextPage}
        hasPrevPage={bundleProductResponse?.hasPrevPage}
        limit={bundleProductResponse?.limit}
        nextPage={bundleProductResponse?.nextPage}
        prevPage={bundleProductResponse?.prevPage}
        disabled={loading}
      />
    </>
  )
}

export default memo(BundleProductTable)
